module.exports = __webpack_public_path__ + "img/td.8c0f4fcb.svg";